import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Col, Row, Divider, notification, Button, Modal } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import employeeService from "../../../services/employee-service";
import { changeDocumentTitle } from "../../../utils/title";

export default function ViewEmployee() {
  const { id } = useParams();
  const navigate = useNavigate()
  const [employee, setEmployee] = useState(null);
  const [selectedDeleteRecord, setSelectedDeleteRecord] = useState(null);
  const [isModalshow, setIsModalShow] = useState(false)


  const showModal = () => {
    setSelectedDeleteRecord(employee?.id)
    setIsModalShow(true)
  }


  const handleCancel = () => {
    setIsModalShow(false)
  };

  const handleDelete = async () => {
    const response = await employeeService.deleteEmployee(selectedDeleteRecord);
    if (response.success) {
      notification.success({
        message: "Employee Deleted Successfully", placement: "topRight"
      })
      navigate(`/administrations/employees`)
    }
    setIsModalShow(false);
  }



  const initialize = async () => {
    const { success, data } = await employeeService.viewEmployee(id);
    if (success) {
      setEmployee(data);
    }
  };

  useEffect(() => {
    changeDocumentTitle("View Employee")

    initialize();
  }, []);

  return (
    <div
      style={{
        padding: "0 14px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
        paddingBottom: "20px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginRight: "auto",
          marginLeft: "auto",
          padding: "10px",
          borderRadius: "8px",
          width: "200px",
          textAlign: "center",
        }}
      >
        {/* Round Image */}
        <div
          style={{
            width: "60px",
            height: "60px",
            borderRadius: "50%",
            overflow: "hidden",
            marginBottom: "15px",
            marginRight: "auto",
            marginLeft: "auto",
          }}
        >
          <img
            src="/images/empview.png"
            alt="User"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </div>

        {/* Name */}
        <div
          style={{
            fontSize: "13px",
            fontWeight: "bold",
            marginBottom: "5px",
          }}
        >
          {employee?.name}
        </div>

        {/* Email */}
        <div
          style={{
            fontSize: "10px",
            color: "#888",
            marginBottom: "20px",
          }}
        >
          {employee?.username}
        </div>

        {/* Edit and Delete Icons */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Link to={`/administrations/employees/form/${employee?.id}`}>
            <EditOutlined
              style={{ fontSize: "20px", cursor: "pointer", marginRight: "10px" }}
            />
          </Link>
          <DeleteOutlined style={{ fontSize: "20px", cursor: "pointer" }} onClick={showModal} />
        </div>
      </div>
      <Divider />
      <Row gutter={24}>
        {[
          { label: "Address", value: employee?.address },
          { label: "CNIC", value: employee?.cnic },
          { label: "Date Of Birth", value: employee?.dob },
          { label: "Qualification", value: employee?.qualification },
          { label: "Salary", value: employee?.salary },
          { label: "Designation", value: employee?.designation },
          {
            label: "Status",
            value: employee?.status === 1 ? "Active" : "Inactive",
          },
        ].map((item, index) => (
          <Col span={24} key={index}>
            <div
              style={{
                display: "flex",
                width: "100%",
                border: "1px solid #d9d9d9",
                borderRadius: 4,
                marginBottom: 2,
              }}
            >
              <div
                style={{
                  flexBasis: "20%",
                  padding: "4px 11px",
                  backgroundColor: "#f5f5f5",
                  borderRight: "1px solid #d9d9d9",
                }}
              >
                {item.label}
              </div>
              <p
                style={{
                  flexBasis: "40%",
                  flexGrow: 1,
                  margin: 0,
                  padding: "4px 11px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {item.value}
              </p>
            </div>
          </Col>
        ))}
        <Col span={24}>
          <div
            style={{
              display: "flex",
              width: "100%",
              border: "1px solid #d9d9d9",
              borderRadius: 4,
              marginBottom: 2,
            }}
          >
            <div
              style={{
                padding: "4px 11px",
                backgroundColor: "#f5f5f5",
                borderRight: "1px solid #d9d9d9",
                flexBasis: "20%",
              }}
            >
              Permissions
            </div>
            <p
              style={{
                flexBasis: "40%",
                flexGrow: 1,
                margin: 0,
                padding: "4px 11px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {employee?.user?.permissions?.map((perm) => perm.name).join(", ") || "N/A"}
            </p>
          </div>
        </Col>
      </Row>

      <Modal
        title={<div style={{ textAlign: 'center' }}>Confirm</div>}
        open={isModalshow}
        onOk={handleDelete}
        onCancel={handleCancel}
        centered
        styles={{
          body: {
            padding: "20px",

          }
        }}
        width={300}
        footer={
          <div className='flex justify-center gap-3'>
            <Button type="default" onClick={handleCancel} style={{ width: "30%" }}>
              Cancel
            </Button>
            <Button type="primary" onClick={handleDelete} style={{ width: "30%" }}>
              Confirm
            </Button>
          </div>
        }
      >
        <p style={{ textAlign: 'center' }}>Are you sure you want to delete this employee?</p>
      </Modal>
    </div>
  );
}
